import { Skeleton } from "@mui/material";
import { Flex } from "~/components/Flex";

export const RemediationRadioSkeleton = () => {
  return (
    <Flex gap={3} flexDirection="column" mt={4.5} mb={3}>
      {Array.from({ length: 3 }).map((_, index) => (
        <Skeleton
          key={index}
          animation="wave"
          variant="rounded"
          height={24}
          width={250}
        />
      ))}
    </Flex>
  );
};
